import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbScmVehicleFinance = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">INDO ZAMBIA BANK AND SOUTHERN CROSS MOTORS LTD PARTNER TO OFFER VEHICLE FINANCE TO THE PUBLIC</h1>
      
              <p className="pb-3">Indo Zambia Bank has partnered with @southerncrossmotors to provide motor vehicle financing to the general public through a Memorandum of Understanding signed yesterday.</p>

              <p className="pb-3">"This partnership between Indo Zambia Bank and Southern Cross Motors Ltd will offer the public competitive financing options, granting them access to some of the world's most sought-after vehicle brands, including Mercedes-Benz, Jeep, Fiat, Mitsubishi, and GWM," said Southern Cross Motors Managing Director, Ronny Palale.
              "In pursuit of our strategic objectives to continuously provide solutions for all customer segments, Indo Zambia Bank is proud to partner with Southern Cross Motors to make it possible for our customers and the general public to acquire quality motor vehicles with Indo Vehicle Finance," said IZB Managing Director, Brajesh Kumar Singh.</p>

            <p className="pb-3"> With Indo Vehicle Finance, you can drive away in your dream car—brand new or pre-owned—at low interest rates, with repayment periods of up to 72 months!</p>

            <ul>
                <li>👉  Available to salaried individuals, businesses, partnerships & sole proprietors</li>
                <li>👉  Take-over loans from other financial institutions</li>
                <li>👉  Reimbursement for vehicles purchased with personal funds</li>
                <li>👉  Swift approvals within 72 hours (with prerequisite documentation)</li>
              </ul>

              <p className="pt-3">For more information call us on <a href="tel:0211226294">0211 226294</a> or email us at <a href="mailto:vaf@izb.co.zm">vaf@izb.co.zm</a> and apply for Indo Vehicle Finance today!</p>

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public-1.jpg" alt="" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public-2.jpg" alt="" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public-3.jpg" alt="" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public-4.jpg" alt="" />
                  </div>
                </Slider>
              </div>
            </div>

            

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbScmVehicleFinance;